export const generateBillingPeriods = (): { value: string; label: string }[] => {
  return generateBillingPeriodOptions(3, 0);
};

/** PDF export API uses `YYYY-MM`; notices use `MM/YYYY` elsewhere. */
export function billingPeriodSlashToDash(period: string): string {
  const trimmed = period.trim();
  if (trimmed.includes('/') && !trimmed.includes('-')) {
    const [month, year] = trimmed.split('/');
    return `${year}-${month.padStart(2, '0')}`;
  }
  return trimmed;
}

/** Thông báo phí export: past kỳ + upcoming (thu trước), values as `YYYY-MM`. */
export function generateFeeNoticeExportPeriodOptions(
  monthsBack = 12,
  monthsForward = 6,
): { value: string; label: string }[] {
  return generateBillingPeriodOptions(monthsBack, monthsForward).map((period) => ({
    value: billingPeriodSlashToDash(period.value),
    label: period.label,
  }));
}

export const generateBillingPeriodOptions = (
  monthsBack = 36,
  monthsForward = 3,
): { value: string; label: string }[] => {
  const periods: { value: string; label: string }[] = [];
  const currentDate = new Date();

  for (let offset = -monthsBack; offset <= monthsForward; offset++) {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + offset, 1);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const value = `${month}/${year}`;
    periods.push({ value, label: `Tháng ${value}` });
  }

  return periods.reverse();
};

export const getCurrentBillingPeriod = (): string => {
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();
  return `Tháng ${month}/${year}`;
}; 